(() => {
  const DURATION_MS = 400;
  const EASING = 'ease';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getPanel = (details) => details.querySelector(':scope > .lvl-accordion__panel');

  const prefersInstant = () => reduceMotion.matches;

  const ensureInner = (panel) => {
    let inner = panel.querySelector(':scope > .lvl-accordion__panel-inner');
    if (inner) return inner;

    inner = document.createElement('div');
    inner.className = 'lvl-accordion__panel-inner';
    while (panel.firstChild) inner.appendChild(panel.firstChild);
    panel.appendChild(inner);
    return inner;
  };

  const clearPanelInline = (panel) => {
    panel.style.height = '';
    panel.style.overflow = '';
    panel.style.transition = '';
  };

  const waitForHeightTransition = (panel) =>
    new Promise((resolve) => {
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        panel.removeEventListener('transitionend', onEnd);
        window.clearTimeout(fallback);
        resolve();
      };
      const onEnd = (event) => {
        if (event.target === panel && event.propertyName === 'height') finish();
      };
      const fallback = window.setTimeout(finish, DURATION_MS + 50);
      panel.addEventListener('transitionend', onEnd);
    });

  const closeAccordion = async (details) => {
    const panel = getPanel(details);
    if (!details.open || !panel) return;

    if (prefersInstant()) {
      clearPanelInline(panel);
      details.open = false;
      details._lvlAccordionAnimating = false;
      return;
    }

    details._lvlAccordionAnimating = true;
    ensureInner(panel);

    panel.style.overflow = 'hidden';
    panel.style.transition = 'none';
    panel.style.height = `${panel.offsetHeight}px`;
    void panel.offsetHeight;

    panel.style.transition = `height ${DURATION_MS}ms ${EASING}`;
    panel.style.height = '0px';
    await waitForHeightTransition(panel);

    details.open = false;
    clearPanelInline(panel);
    details._lvlAccordionAnimating = false;
  };

  const openAccordion = async (details) => {
    const panel = getPanel(details);
    if (details.open || !panel) return;

    if (prefersInstant()) {
      details.open = true;
      details._lvlAccordionAnimating = false;
      return;
    }

    details._lvlAccordionAnimating = true;
    ensureInner(panel);

    panel.style.overflow = 'hidden';
    panel.style.transition = 'none';
    panel.style.height = '0px';
    details.open = true;

    panel.style.height = 'auto';
    const target = panel.offsetHeight;
    panel.style.height = '0px';
    void panel.offsetHeight;

    panel.style.transition = `height ${DURATION_MS}ms ${EASING}`;
    panel.style.height = `${target}px`;
    await waitForHeightTransition(panel);

    clearPanelInline(panel);
    details._lvlAccordionAnimating = false;
  };

  const closeExclusiveGroup = (openingDetails) => {
    const name = openingDetails.getAttribute('name');
    if (!name) return;

    const selector = `details.lvl-accordion__item[name="${CSS.escape(name)}"][open]`;
    document.querySelectorAll(selector).forEach((other) => {
      if (other !== openingDetails) closeAccordion(other);
    });
  };

  const onSummaryClick = (event) => {
    const summary = event.currentTarget;
    const details = summary.closest('details.lvl-accordion__item');
    if (!details) return;

    event.preventDefault();
    if (details._lvlAccordionAnimating) return;

    if (details.open) {
      closeAccordion(details);
      return;
    }

    closeExclusiveGroup(details);
    openAccordion(details);
  };

  document.querySelectorAll('.livana-landing details.lvl-accordion__item').forEach((details) => {
    const panel = getPanel(details);
    if (panel) ensureInner(panel);

    const summary = details.querySelector(':scope > .lvl-accordion__summary');
    if (!summary) return;
    summary.addEventListener('click', onSummaryClick);
  });
})();
